import { useAccountAspect } from "@oysterhr/identity/AccountAspectContext"
import { Trans, useTranslation } from "react-i18next"
import { useNavigate } from "react-router-dom"
import { Text, Button, Link, Heading, Alert } from "@oysterhr/ui"

import { OverviewStep } from "../../../../../components/OverviewStep"
import { PaymentEngagementType } from "../../../../../enums"
import { companyNewAchFlowPath } from "../../../../../../../utils/routeHelpers"
import { HC_ARTICLE } from "../../constants"

const FTE_SETUP_STEPS = [
  {
    title: "fte.steps.addPaymentMethod.title",
    content: "fte.steps.addPaymentMethod.content",
  },
  {
    title: "fte.steps.authorization.title",
    content: "fte.steps.authorization.content",
  },
  {
    title: "fte.steps.verification.title",
    content: "fte.steps.verification.content",
  },
]

export const AchFteSetupSteps = () => {
  const navigate = useNavigate()
  const { accountAspect: companyId } = useAccountAspect()
  const { t } = useTranslation("company_interface/CompanyPaymentMethodsPage/AchLandingPage")

  const handleContinue = () => {
    navigate(companyNewAchFlowPath(companyId, PaymentEngagementType.Fte))
  }

  return (
    <>
      <div className="flex flex-col gap-6">
        <div>
          <Text className="text-base font-semibold leading-6">{t("whatDoesAchDo.question")}</Text>
          <Text size="medium" className="mt-2 text-base font-normal leading-6">
            {t("whatDoesAchDo.answer")}
          </Text>
        </div>
        <div>
          <Text className="text-base font-semibold leading-6">
            {t("whichInvoicesWillBePaid.question")}
          </Text>
          <Text size="medium" className="mt-2 text-base font-normal leading-6">
            {t(`whichInvoicesWillBePaid.answer.${PaymentEngagementType.Fte}`)}
          </Text>
        </div>
      </div>
      <Alert variation="info" className="mt-2">
        <Alert.Icon />
        <Alert.Content>
          <Text size="medium" className="text-base font-normal leading-6">
            {t("alert")}
          </Text>
        </Alert.Content>
      </Alert>
      <div className="mt-6">
        <Heading size="lg">{t("stepsHeader")}</Heading>
        <ul className="mt-2 grid grid-cols-1 justify-items-start gap-4 rounded-lg border-2 border-gray-200 p-4">
          {FTE_SETUP_STEPS.map((step, index) => (
            <OverviewStep
              key={step.title}
              title={t(step.title)}
              content={t(step.content)}
              step={index + 1}
            />
          ))}
        </ul>
      </div>
      <div className="mt-6">
        <Text size="small" className="text-sm font-semibold leading-5 text-gray-400">
          {t("note")}
        </Text>
        <Text size="small" className="text-sm font-normal leading-5 text-gray-400">
          {t("noteDescription")}
        </Text>
      </div>
      <div className="my-6">
        <Trans
          t={t}
          i18nKey="details"
          components={{
            a: <Link to={HC_ARTICLE} className="inline-block font-normal" target="_blank" />,
          }}
        />
      </div>
      <Button variation="primary" size="md" onClick={handleContinue}>
        {t("continue")}
      </Button>
    </>
  )
}
